import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { routes } from '@/app/routes'
import { Brand } from '@/components/shared/Brand'
import { AccountMenu } from '@/components/navigation/AccountMenu'
import { CommandMenu } from '@/components/navigation/CommandMenu'
import { NotificationsPopover } from '@/components/navigation/NotificationsPopover'
import { ShortcutsDialog } from '@/components/navigation/ShortcutsDialog'
import { shellStrings as s } from '@/components/navigation/strings'
import { useUser } from '@/features/auth/useSession'
import { useUnreadCount } from '@/features/notifications/useUnreadCount'
import { env } from '@/config/env'
import { mediaUrl } from '@/lib/utils'
import { fullName } from '@/types/models'
import { DsAvatar, DsBadge, DsIconButton, DsIconGlyph, DsIcons, DsKbd, modKeyLabel, useHotkey, useIsPhone } from '@/ds'

export function TopBar() {
  const user = useUser()
  const unreadCount = useUnreadCount()
  const navigate = useNavigate()
  const phone = useIsPhone()
  const [paletteOpen, setPaletteOpen] = useState(false)
  const [shortcutsOpen, setShortcutsOpen] = useState(false)
  useHotkey('?', () => setShortcutsOpen(true), { enabled: !phone })
  if (!user) return null
  return (
    <header className="sticky top-0 z-10 flex h-16 items-center justify-between gap-4 border-b bg-background/80 px-gutter backdrop-blur md:px-6 lg:px-8">
      <Brand size="sm" className="md:hidden" />
      {!phone && (
        <button
          type="button"
          onClick={() => setPaletteOpen(true)}
          className="flex h-control-sm w-full max-w-md items-center gap-2 rounded-lg border bg-card px-3 text-small text-muted-foreground outline-none transition-colors motion-fast hover:border-ring/40 focus-visible:ring-focus"
        >
          <DsIconGlyph icon={DsIcons.search} size={16} />
          <span className="flex-1 truncate text-left">{s.search}</span>
          <span className="hidden gap-1 lg:flex">
            <DsKbd>{modKeyLabel()}</DsKbd>
            <DsKbd>K</DsKbd>
          </span>
        </button>
      )}
      <div className="flex items-center gap-1">
        {phone ? (
          <>
            <DsIconButton
              icon={DsIcons.bell}
              semanticLabel={unreadCount > 0 ? `${s.notifications}, ${unreadCount}` : s.notifications}
              onClick={() => navigate(routes.notifications)}
              badge={unreadCount > 0 ? <DsBadge.Count value={unreadCount} size="xs" /> : undefined}
            />
            <Link to={routes.account} aria-label={s.settings} className="inline-flex size-11 items-center justify-center rounded-full outline-none hover:bg-muted focus-visible:ring-focus">
              <DsAvatar name={fullName(user)} imageUrl={mediaUrl(user.avatar, env.mediaHost)} size="sm" />
            </Link>
          </>
        ) : (
          <>
            <NotificationsPopover />
            <AccountMenu />
          </>
        )}
      </div>
      <CommandMenu open={paletteOpen} onOpenChange={setPaletteOpen} />
      <ShortcutsDialog open={shortcutsOpen} onOpenChange={setShortcutsOpen} />
    </header>
  )
}
